import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "customReasonLabelWithInput", "reasonTypeInput", "customReasonInput"]

  connect() {
    this.selectReasonType({ target: this.reasonTypeInput });
  }

  selectReasonType() {
    if(this.reasonTypeInputTarget.value == 'custom') {
      this.customReasonLabelWithInputTarget.classList.remove('hidden')
      this.customReasonInputTarget.value = ""
    } else if (this.reasonTypeInputTarget.value != 'custom' && !this.customReasonLabelWithInputTarget.classList.contains("hidden")) {
      this.customReasonLabelWithInputTarget.classList.add('hidden')
      this.customReasonInputTarget.value = ""
    }

    if(this.reasonTypeInputTarget.value != 'custom') {
      this.customReasonInputTarget.value = this.reasonTypeInputTarget.selectedOptions[0].text
    }
  }

  updateStatus(event) {
    event.preventDefault
    this.element.requestSubmit()
  }
}
